import { render, staticRenderFns } from "./order-view-info.vue?vue&type=template&id=573c98c8&"
import script from "./order-view-info.ts?vue&type=script&lang=ts&"
export * from "./order-view-info.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports